import Category from "./Category";

class Product {
  id;
  name;
  caracteristics;
  description;
  prise;
  oldPrise;
  image;
  categoryMembership;
  creationDate;

  constructor(data) {
    this.init(data);
  }

  init(data) {
    const {
      id,
      name,
      caracteristics,
      description,
      prise,
      oldPrise,
      image,
      categoryMembership,
      creationDate,
    } = data;

    if (
      !id ||
      !name ||
      !caracteristics ||
      !description ||
      !prise ||
      !oldPrise ||
      !image ||
      !categoryMembership ||
      !creationDate
    ) {
      throw new Error("Invalid product data");
    }

    this.id = id;
    this.name = name;
    this.caracteristics = caracteristics;
    this.description = description;
    this.prise = prise;
    this.oldPrise = oldPrise;
    this.image = image;
    this.categoryMembership = categoryMembership;
    this.creationDate = creationDate;
  }

  //some getters
  get getId() {
    return this.id;
  }

  get getName() {
    return this.name;
  }

  get getCaracteristics() {
    return this.caracteristics;
  }

  get getDescription() {
    return this.description;
  }

  get getPrise() {
    return this.prise;
  }

  get getOldPrise() {
    return this.oldPrise;
  }

  get getImage() {
    return this.image;
  }

  get getCategoryMembership() {
    return this.categoryMembership;
  }

  get getCreationDate() {
    return this.creationDate;
  }

  update(data) {
    const {
      name,
      caracteristics,
      description,
      prise,
      oldPrise,
      image,
      categoryMembership,
    } = data;

    this.name = name ? name : this.name;
    this.caracteristics = caracteristics ? caracteristics : this.caracteristics;
    this.description = description ? description : this.description;
    this.prise = prise ? prise : this.prise;
    this.oldPrise = oldPrise ? oldPrise : this.oldPrise;
    this.image = image ? image : this.image;
    this.categoryMembership = categoryMembership
      ? categoryMembership
      : this.categoryMembership;
  }
}

export default Product;
